<div class="py-40 px-10 text-center text-xl text-bold">
  @if (isLoading) {
    <div class="flex flex-col items-center justify-center py-6">
      <i class="icon icon-privacy animate-pulse text-6xl kiosk-xl:text-8xl"></i>
      <div class="py-12 text-4xl font-bold kiosk-xl:text-6xl">
        {{ 'viva-wallet-terminal.creating-order' | translate }}
      </div>
    </div>
  }

  @if (!isLoading && !isOnError) {
    <div class="flex items-center justify-center py-6 text-4xl font-bold kiosk-xl:text-6xl">
      {{ (terminalInstructionMessage() || 'viva-wallet-terminal.verifying-payment') | translate }}
    </div>
  }

  @if (errorMessage) {
    <div class="mt-12 text-center text-4xl text-error-800 kiosk-xl:text-6xl">
      {{ errorMessage }}
    </div>
  }

  @if (isOnError) {
    <div class="mt-12 flex flex-row justify-center">
      <app-button-atom
        size="XXL"
        thickSize="XXL"
        type="primary"
        [label]="'viva-wallet-terminal.retry' | translate"
        (clickEventEmitter)="createOrderAndPay()"
      ></app-button-atom>
    </div>
    <div class="mt-12 flex flex-row justify-center">
      <app-button-atom
        size="XXL"
        thickSize="XXL"
        type="light"
        [label]="'viva-wallet-terminal.back-to-cart' | translate"
        (clickEventEmitter)="backToCart()"
      ></app-button-atom>
    </div>
  }
</div>

@if (loadKioskResetTimer) {
  <app-kiosk-cart-reset-timer-block
    [config]="{ 'wait_for_user_interaction_to_display_modal': false }"
  ></app-kiosk-cart-reset-timer-block>
}
